<script setup lang="ts">
import type { BaseSectionStoryblok } from '~/component-types-sb'

const props = defineProps<{ blok: BaseSectionStoryblok }>()
const milkyBg = computed(() => props.blok.milky_bg ? 'bg-milky-200' : '')
</script>

<template>
  <div :class="milkyBg">
    <div v-editable="props.blok">
      <div class="rounded-md overflow-hidden">
        <div class="md:px-6 px-5 md:py-8 py-10">
          <h2 :id="props.blok._uid" class="md:text-h2 text-m-h2" v-html="props.blok.title" />
          <div>
            <StoryblokComponent v-for="adviceText in blok.base_blocks" :key="adviceText.id" :blok="adviceText" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
